// extracted by mini-css-extract-plugin
module.exports = {"paymentMethodMessage":"style_paymentMethodMessage__ABzse"};